import React from 'react'

class RFSelectInput extends React.Component {
  render(){
    let {input, type, placeholder, meta: {touched, error}} = this.props
    return (
        <div className={this._wrapperClassName()}>
            <select
                {...input}
                className={`form-control`}
                onChange={this._onChange}
            >
              {this.props.children}
            </select>
            {touched && error && <span className='form-feedback'>{error}</span>}
          </div>
      )
  }

  _wrapperClassName = () => {
    const {meta: {touched, error}} = this.props
    return `${touched ? (error ? 'has-feedback has-error' : 'has-feedback has-success') : ''}`
  }

  _onChange = (e) => {
    const {input: {onChange}} = this.props
    onChange(e)
  }
}

export {RFSelectInput}


// WEBPACK FOOTER //
// app/javascript/components/fields/SelectInput/SelectInput.js